import React from "react";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./themes/theme";
import { GlobalStyles } from "./themes/global";
import { useDarkMode } from "./themes/useDarkmode";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import NoMatch from './components/404/404';
import Footer from './components/Home/Contact/Contact';
import Root from './components/Root/Root'
import Photography from "./components/Home/Photography/Photography";
import Portfolio from "./components/Home/Projects/ProjectsPages";
import Resources from "./components/Home/Resources/Resources";
import ResourceSingle from "./components/Home/Resources/ResourceSingle";
function App() {
  const [theme, componentMounted] = useDarkMode();
  const themeMode = theme === "light" ? lightTheme : darkTheme;

  if (!componentMounted) {
    return <div />;
  }

  return (

 <ThemeProvider theme={themeMode}>
      <>
        <GlobalStyles />
        <Router>
     
          <Switch>
            <Route exact path="/" component={Root}/>
            {/* <Route path="/photography" component={Photography} />  */}
            <Route path ="/portfolio/:slug" component={Portfolio}/>
            <Route path="/resources/:slug" component={ResourceSingle}/>
            {/* <Route exact path="/resources" component={Resources}/> */}
   
            <NoMatch />
          </Switch>
        </Router>
        <Footer/>
      </>
    </ThemeProvider>

   
  );
}

export default App;
